import { useState, type FormEvent } from 'react';
import { Button, Card, Field } from '../components/kit';
import { api, ApiRequestError } from '../api/client';
import './page.css';

export function ChangePassword() {
  const [currentPassword, setCurrent] = useState('');
  const [newPassword, setNew] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setMsg(null);
    if (newPassword !== confirm) {
      setMsg({ ok: false, text: 'Yeni şifreler eşleşmiyor' });
      return;
    }
    setBusy(true);
    try {
      await api.post('/auth/change-password', { currentPassword, newPassword });
      setMsg({ ok: true, text: 'Şifreniz güncellendi' });
      setCurrent('');
      setNew('');
      setConfirm('');
    } catch (err) {
      setMsg({ ok: false, text: err instanceof ApiRequestError ? err.message : 'İşlem başarısız' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page">
      <div className="page-head">
        <div className="page-eyebrow">Güvenlik</div>
        <h1>Şifre Değiştir</h1>
      </div>
      <Card className="form-card">
        <form className="auth-form" onSubmit={onSubmit}>
          {msg && (
            <div className={msg.ok ? 'ok-banner' : 'auth-error'}>{msg.text}</div>
          )}
          <Field label="Mevcut şifre" id="cur" type="password" autoComplete="current-password"
            value={currentPassword} onChange={(e) => setCurrent(e.target.value)} required />
          <Field label="Yeni şifre (en az 8 karakter)" id="new" type="password" autoComplete="new-password"
            value={newPassword} onChange={(e) => setNew(e.target.value)} required />
          <Field label="Yeni şifre (tekrar)" id="confirm" type="password" autoComplete="new-password"
            value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
          <Button type="submit" disabled={busy}>
            {busy ? 'Güncelleniyor…' : 'Şifreyi güncelle'}
          </Button>
        </form>
      </Card>
    </div>
  );
}
